RivalIQ.apps.SocialChannelMatrix.module('views', function (views, App, Backbone, Marionette, $, _, moment, s, formatter) {

    'use strict';

    function formatUpdatedDateNoTimezone(sinceDate) {
        if (sinceDate) {
            const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';
            const sinceDateInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, sinceDate);

            return sinceDateInTz.format('MMM D, YYYY');
        }
        return null;
    }

    views.MatrixListItemPopover = Marionette.ItemView.extend({
        ui: {
            changeRequestLink: '.x-change-request-link',
            learnMoreLink: '.x-learn-more-link'
        },
        events: {
            'click @ui.changeRequestLink': 'onChangeRequestLinkClick',
            'click @ui.learnMoreLink': 'onLearnMoreClick'
        },

        audienceSizeFormat: 'f',

        getTemplate: function () {

            const me = this;
            return me.options.channelStatus.popoverTemplate;
        },

        serializeData: function () {

            const me = this;
            const model = me.model;
            const data = model.toJSON();
            const excludedCompanyIds = _.get(RivalIQ.state.landscape.get('auditSettings'), 'excludedCompanyIds', []);
            const isNotEditable = _.includes(excludedCompanyIds, data.company.id);

            return _.extend(data, {
                audience: me.getAudienceSize(),
                earliestPostData: me.getEarliestPostData(),
                relativePostData: me.getRelativePostData(),
                earliestPresenceData: me.getEarliestPresenceData(),
                relativePresenceData: me.getRelativePresenceData(),
                lastPostDataUpdate: me.getLastDataUpdate(),
                relativePostDataUpdate: me.getRelativeDataUpdate(),
                lastPresenceDataUpdate: me.getLastDataUpdate(),
                relativePresenceDataUpdate: me.getRelativeDataUpdate(),
                noEditText: RivalIQ.strings.company_not_editable,
                channelRecord: me.getChannelRecord(),
                companyRecord: model.get('company').toJSON(),
                audienceLabel: model.get('channel').audienceMetricLabel,
                overviewSafeLength: me.getOverviewSafeLength(),
                landscapeNameDecorated: me.getChannelDecoratedHandle(),
                landscapeName: me.getChannelHandle(),
                profileLink: me.getChannelNativeLink(),
                hideChangeRequest: RivalIQ.state.account.trialExpired() || !RivalIQ.state.user.can('update', RivalIQ.state.landscape) || isNotEditable,
                is1xux: me.options.is1xux,
                showNotBusinessInstagramWarning: me.options.showNotBusinessInstagramWarning
            });
        },

        onChangeRequestLinkClick: function () {

            const me = this;
            const model = me.model;
            const company = model.get('company');

            me.trigger('close');

            const modal = new RivalIQ.suggestion.views.Modal({
                model: new Backbone.Model({
                    companyId: company.id,
                    companyName: company.get('name'),
                    channelHandle: me.getChannelHandle(),
                    decoratedHandle: me.getChannelDecoratedHandle(),
                    source: model.get('channel').source,
                    currentPresence: model
                })
            });

            me.listenToOnce(modal, 'submit', me.setChangeRequest);

            RivalIQ.apps.Shell.execute('show:modal', modal);
        },

        onLearnMoreClick: function () {
            window.open('https://help.rivaliq.com/en/articles/6746797-why-can-t-i-edit-a-free-benchmark-landscape', '_blank');
        },

        getChannelRecord: function () {

            const me = this;
            const channel = me.model.get('channel');
            const company = me.model.get('company');
            return company.getPrimaryRecord(channel.source);
        },

        getChannelRecordDate: function (key, forRelativeDate) {

            const me = this;
            const date = _.get(me.getChannelRecord(), ['dates', key]);

            if (date) {
                return moment.utc(date);
            } else {
                return null;
            }
        },

        setChangeRequest: function (didEdit) {

            const me = this;
            me.model.set({
                hasChangeRequest: true,
                hasUserEdit: didEdit
            });
            me.model.trigger('userChangeRequest');
        },

        getAudienceSize: function () {

            const me = this;
            const channel = me.model.get('channel');
            const channelRecord = me.getChannelRecord();

            const audience = _.get(channelRecord, ['period2', channel.audienceMetricKey], _.get(channelRecord, 'presence.reach'));

            return (_.isFinite(audience) ? formatter.formatAbbreviated(audience, me.audienceSizeFormat) : null);
        },

        getEarliestPostData: function () {

            const me = this;
            const sinceDate = me.getChannelRecordDate('earliestPostData');
            return formatUpdatedDateNoTimezone(sinceDate);
        },

        getRelativePostData: function () {

            const me = this;
            const sinceDate = me.getChannelRecordDate('earliestPostData');
            return (sinceDate ? sinceDate.fromNow() : null);
        },

        getEarliestPresenceData: function () {

            const me = this;
            const sinceDate = me.getChannelRecordDate('earliestPresenceData');
            return formatUpdatedDateNoTimezone(sinceDate);
        },

        getRelativePresenceData: function () {

            const me = this;
            // NOTE see hackorama note in dataServiceProto.generatePresencePeriodSummary
            const sinceDate = me.getChannelRecordDate('earliestPresenceDataUtc') || me.getChannelRecordDate('earliestPresenceData');
            return (sinceDate ? sinceDate.fromNow() : null);
        },

        getLastDataUpdate: function () {

            const me = this;
            const sinceDate = me.getChannelRecordDate('latestData');
            return formatUpdatedDateNoTimezone(sinceDate);
        },

        getRelativeDataUpdate: function () {

            const me = this;
            const sinceDate = me.getChannelRecordDate('latestData');
            return (sinceDate ? sinceDate.fromNow() : null);
        },

        getOverviewSafeLength: function () {

            const me = this;
            let overview = null;
            const channelRecord = me.getChannelRecord();

            if (channelRecord && channelRecord.presence) {

                overview = s.truncate(channelRecord.presence.overview, 140);
            }

            return overview;
        },

        getChannelDecoratedHandle: function () {

            const me = this;
            const channel = me.model.get('channel');
            const companyRecord = me.model.get('company').toJSON();

            return (channel.getChannelDecoratedHandle ? channel.getChannelDecoratedHandle(companyRecord) : me.getChannelHandle());
        },

        getChannelHandle: function () {

            const me = this;
            const channelRecord = me.getChannelRecord();

            if (!channelRecord) {

                return;
            }

            return channelRecord.presence.display_name || channelRecord.presence.handle || channelRecord.presence.title || channelRecord.presence.native_id;
        },

        getChannelNativeLink: function () {

            const me = this;
            const channel = me.model.get('channel');
            const companyRecord = me.model.get('company').toJSON();
            return channel.getChannelNativeLink(companyRecord);
        }
    });

}, window.moment, window.s, RivalIQ.formatter);
